/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import HeaderComponent from "../Header";
import Footer from "../Footer";
import PreOperationsHistory from "./PreOperations/HistoryMobile";
import "./Modules.css";

import Dashboard from "./Dashboard/Dashboard";
import Settings from "./Settings/Settings";
import Profile from "./Profile/Profile";
import ChangePassword from "./Profile/ChangePassword";
import PreOperationalForm from "./PreOperations/PreOperationalForm";
import FirmaConductor from "./FirmaConductor/FirmaConductor";
import FirmaGuard from "../FirmaGuard";
import FuecList from "./FUEC/FuecList";
import FuecDetail from "./FUEC/FuecDetail";

import { useMediaQuery, useTheme } from "@mui/material";
import { useUser } from "../../UserContext";
import { esAdministrador } from "../../utils/perfil";

const { Content } = Layout;

function Modules() {
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));
  const location = useLocation();
  const { user } = useUser();
  // Pantallas propias del conductor: el administrador de vehículos solo consulta traslados
  const soloConductor = (elemento) =>
    esAdministrador(user) ? <Navigate to="/modules/Dashboard" replace /> : elemento;

  const [open, setOpen] = useState(!isMobile);

  useEffect(() => {
    setOpen(!isMobile);
  }, [isMobile]);

  const toggleDrawer = () => setOpen(!open);

  // Rutas que necesitan vista completa sin restricciones (sin padding/margin del contenido)
  const isFullViewRoute = location.pathname.includes('ChangePassword') ||
                         location.pathname.includes('Settings') ||
                         location.pathname.includes('Profile') ||
                         location.pathname.includes('PreOperations') ||
                         location.pathname.includes('Dashboard') ||
                         location.pathname.includes('PreOperationalForm') ||
                         location.pathname.includes('Firma') ||
                         location.pathname.includes('fuec');

  return (
    <FirmaGuard>
      <Layout style={{ minHeight: "100vh" }} className="custom-layout">
        <Sidebar open={open} toggleDrawer={toggleDrawer} />
        <Layout
          className="site-layout"
          style={{
            marginLeft: (open && !isMobile) ? 250 : 0,
            transition: "all 0.2s",
            background: 'transparent',
          }}
        >
          <HeaderComponent toggleSidebar={toggleDrawer} />
          <Content style={{
            margin: isFullViewRoute ? "0" : "0 16px",
            background: 'transparent',
            overflow: 'initial',
          }}>
            <div
              style={{
                padding: isFullViewRoute ? 0 : 24,
                minHeight: 'calc(100vh - 64px - 70px)', // Altura total menos header y footer
                background: 'transparent',
                borderRadius: 0,
              }}
            >
              <Routes>
                <Route path="/" element={<Navigate to="Dashboard" />} />
                <Route path="Dashboard" element={<Dashboard />} />
                <Route path="PreOperations" element={soloConductor(<PreOperationsHistory />)} />
                <Route path="PreOperationalForm" element={soloConductor(<PreOperationalForm />)} />
                <Route path="Settings" element={soloConductor(<Settings />)} />
                <Route path="Profile" element={soloConductor(<Profile />)} />
                <Route path="Firma" element={soloConductor(<FirmaConductor />)} />
                <Route path="ChangePassword" element={<ChangePassword />} />
                <Route path="fuecs" element={soloConductor(<FuecList />)} />
                <Route path="fuec/:id" element={soloConductor(<FuecDetail />)} />
              </Routes>
            </div>
          </Content>
          <Footer />
        </Layout>
      </Layout>
    </FirmaGuard>
  );
}

export default Modules;
